import KForm from 'app/components/Modules/Form/_KForm'
import { _KFormProps } from 'app/components/Modules/Form/typing'
import Button from 'app/components/UI-Elements/General/Button'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import { RecordTypeEnum } from 'app/queries'
import { omit } from 'lodash'
import React, { ComponentProps } from 'react'

import useAddressSearch from '../../Checkout/hooks/useAddressSearch'
import { MemberProps } from '../../convention'
import AddressInputs from './AddressInputs'

type Props = {
  formProps?: Partial<_KFormProps<Partial<IRental>>>
  addressInputProps?: ComponentProps<typeof AddressInputs>
  allowProjectSelection?: boolean
}

const DeliveryAddressForm: React.FC<MemberProps<IDeliveryAddress, Props>> = ({
  member,
  props: { formProps = {}, addressInputProps, allowProjectSelection } = {}
}) => {
  const addressSearch = useAddressSearch()
  const { tButtonTitle } = useTranslation({
    componentType: 'feedback',
    scope: 'drawer.title',
    recordType: RecordType.delivery_address
  })

  const payloadNormalizer = (data: IDeliveryAddress) => {
    const getAsFloat = (key: keyof IDeliveryAddress) => parseFloat(data[key] as string)

    const basePayload = {
      rentalId: data.id,
      ...omit(data, 'addressSummary'),
      longitude: getAsFloat('longitude'),
      latitude: getAsFloat('latitude')
    }

    if (!member?.project && !basePayload.project?.name) {
      return omit(basePayload, 'project')
    } else {
      return basePayload
    }
  }

  const openSearch = () => {
    addressSearch.open({
      rental: member as IRental,
      showAvailabilityHint: true
    })
  }
  const searchExtra = (
    <Button onClick={openSearch} title={tButtonTitle({ id: 'select_project' })} type="secondary" />
  )

  return (
    <KForm<IDeliveryAddress>
      recordType={RecordTypeEnum.rentalDeliveryAddress}
      baseRecordType={RecordTypeEnum.rental}
      initialValues={{
        ...member
      }}
      recordId={member?.id}
      initialFetch={false}
      layout="vertical"
      mutationOptions={{
        silentSuccess: true,
        payloadNormalizer
      }}
      {...formProps}>
      <AddressInputs
        searchExtra={allowProjectSelection ? searchExtra : undefined}
        {...addressInputProps}
      />
    </KForm>
  )
}

export default DeliveryAddressForm
